const userAgent = window.navigator.userAgent;

/**
 * Check whether the browser is Internet Explorer.
 * @return {Bool}
 */

export const isIE = () => {
  return userAgent.indexOf('Trident/') > 0;
};

/**
 * Check whether the browser is Edge.
 * @return {Bool}
 */

export const isEdge = () => {
  return userAgent.indexOf('Edge/') > 0;
};
